module.exports = __webpack_public_path__ + "static/media/flashBlank.f72cd419.svg";